import axios from 'axios';

const getLockboxPhotoByListing = async (dashboardId: string) => {
  const data = await axios.get(`/external/dash/${dashboardId}/lockbox_photo`);

  return data;
};

export default getLockboxPhotoByListing;
